<template>
    
    <b-row>
        <b-col md="12">
            <div slot="header">
              <b-row>
                  <b-col>
                    <center>
                    <strong> Current Attendace Status</strong> 
                    </center>
                    </b-col>
              </b-row>   
          </div>
        <div id="listloader" v-if="isloader">
            <div class="listloader"></div>
        </div>
        
            <div class="container px-0 mt-2" >
            <div class="row">
                <div class="col-xl-12 col-18">
                  
                <div class="card" >
                    <div class="card-body p-1">
                        <div class="chartpiechartviews" >
                        <canvas class="containermasterbarchart chartjs" data-height="250" height="100"></canvas>
                    </div>
                    
                    </div>
                </div>
                <!-- <table v-else>
                        <tbody> <tr>
                                            <td colspan="12"><b>No Records Found</b></td>
                                        </tr>
                                    </tbody>
                                </table> -->
                </div>
            </div>
        </div>
          
        </b-col>
    </b-row>
</template>

<script>
import CONSTANTS from '@/utils/constants'
import Utils from '@/utils'
import Vue from 'vue'
import VueApexCharts from 'vue-apexcharts';
import $ from 'jquery';
import Chart from 'chart.js/auto'; // or 'chart.js'
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import VueTimepicker from 'vue2-timepicker'
import 'vue2-timepicker/dist/VueTimepicker.css'
import { cosh } from 'core-js/core/number';
export default {
components:{
    VueApexCharts,
    apexchart: VueApexCharts,
    DatePicker,
    VueTimepicker
},
props:{
    chartdata:{
        type:Array,
        required:false
    },
    shiftdata:{
        type:String,
        required:true
    },
    time3:{
        type:Array,
        required:true
    }

},
data() {
    return {
        isBusy: false, 
      
        fields :[],
        EBN_expriryCount :[],
        isBusy : false,
        noofpages:'',
        pageNum:1,
        searching :[],
        searchvaluesarr:[],
        totalRows :0,
        CheckLoadID :[],
        SelectLoadID :[],
        selectDateFrom: '',
        route_id : null,
        isCheckAll: false,
        //time3: [new Date(), new Date()],
        starttime:'',
        endtime:'',
        customFormat: 'yyyy-MM-dd',
        selected:'',
        // shiftdata:'1st',
        // listdata:[],
         isloader : false,
        // shiftlist :[],
        chartnorecords : [{
            "attendance_starttime": "",
            "attendance_endtime": "",
            "hubname":"Data Not Found",
            "empcount": "0"
            }]
    }
},
watch: {
    chartdata: 'getshowbarcharts'
    },
created() {
    var userdata = localStorage.getItem("userData");
    var userInfo = JSON.parse(userdata);
    this.User_type = userInfo.user_type;
    console.log("userInfo", userInfo);
    this.route_id = this.$route.params.id;
},
mounted(){
 this.getshowbarcharts()
//this.getreportdata();
 //  this.getshiftdata()
},
methods: {
    getshowbarcharts() {
         let datac = this.chartdata.length > 0 ? this.chartdata : this.chartnorecords
    if (datac.length > 0) {
         let hublabels = [];
        let empcount = [];
        let hiddenValues = [];
        for (let a = 0; a < datac.length; a++) {
            if (datac[a].hubname !== null && datac[a].attendance_starttime !== null && datac[a].attendance_endtime !== null )  {

                let mlabels = datac[a].attendance_starttime +'-'+datac[a].attendance_endtime+'\n'+datac[a].hubname
                hublabels.push(mlabels);
                empcount.push(datac[a].empcount);
                hiddenValues.push(datac[a].premiseid);
            }
        }
        let closingRatio = datac.map(item => {
            let ratio = parseFloat(item.empcount);
            return isNaN(ratio) ? null : ratio.toFixed(2);
        });
        let barChartEx1 = $('.containermasterbarchart');
         if (barChartEx1.length) {
            if (this.barChartExample2) {
                this.barChartExample2.destroy();
            }
            this.barChartExample2 = new Chart(barChartEx1, {
                type: 'bar',
                data: {
                    labels: hublabels,
                    datasets: [{
                        label: 'Employee Count',
                        data: closingRatio,
                        backgroundColor: '#6495ED',
                        borderColor: 'transparent',
                        hoverBackgroundColor: '#483D8B',
                        maxBarThickness: 18,
                        borderSkipped: 'bottom',
                        hiddenValues: hiddenValues
                    }]
                },
                options: {
                    scales: {
                       
                    },
                    plugins: {
        datalabels: {
            display: true,
            anchor: 'end',
            align: 'end',
            color: 'black',
            formatter: (value, context) => {
                return value;
            }
        }
    },
                    elements: {
                        line: {
                            tension: 0
                        }
                    },
                    onClick: this.chartClickHandler.bind(this),
                    animation: {
             onComplete: function() {
            const chartInstance = this;
            const ctx = chartInstance.ctx;
            ctx.font = `${Chart.defaults.font.size}px ${Chart.defaults.font.family}`;
            ctx.textAlign = 'center';
            ctx.textBaseline = 'bottom';

            this.data.datasets.forEach(function(dataset) {
                const meta = chartInstance.getDatasetMeta(0);
                meta.data.forEach(function(bar, index) {
                    const data = dataset.data[index];
                    ctx.fillText(data, bar.x, bar.y - 5); // Adjust the offset as needed
                });
            });
        }
    }
                }
            });
        }
    } else {
        if (this.barChartExample2) {
            this.barChartExample2.destroy();
        }
    }
},
chartClickHandler(event) {
  const activePoints = this.barChartExample2.getElementsAtEventForMode(event, 'nearest', { intersect: true }, true);
   if (activePoints.length > 0) {
   
    const clickedDatasetIndex = activePoints[0].datasetIndex;
    const clickedElementIndex = activePoints[0].index;

  
    const label = this.barChartExample2.data.labels[clickedElementIndex];
    const value = this.barChartExample2.data.datasets[clickedDatasetIndex].data[clickedElementIndex];
    const hiddenvalue = this.barChartExample2.data.datasets[clickedDatasetIndex].hiddenValues[clickedElementIndex];

    let splithubname = label.split('\n');
     // this.$router.push({ path: '/fcclock_datatable/'+label+'/'+ value });
     let timerangedata = this.time3

    let shift = this.shiftdata ? this.shiftdata.toLowerCase() : '1st'
    let shiftstartdate = this.formatDate(timerangedata[0])
    let shiftenddate = this.formatDate(timerangedata[1])

    let newPageUrl = this.$router.resolve({ path: '/fcclock_datatable/attendance'+ '/' + hiddenvalue+'/'+shift+'/'+shiftstartdate+'/'+shiftenddate }).href;
    window.open(newPageUrl, '_blank');
  }
},formatDate: function(date) {
        var d = new Date(date),
            month = "" + (d.getMonth() + 1),
            day = "" + d.getDate(),
            year = d.getFullYear();
        if (month.length < 2) month = "0" + month;
        if (day.length < 2) day = "0" + day;
        return [year, month, day].join("-");

    }
},  
}
</script>

